/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-01 17:29:18
 * @Last Modified by: Josselin Hubert
 * @Last Modified time: 2020-09-11 01:09:59
 */


export default {
  appName: "Premium Development",

  button: {
    cancel: 'Annuler',
    clear: 'Effacer',
    close: 'Fermer',
    contactUs: 'Contactez nous',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    knowMore: 'En savoir plus',
    next: 'Suivant',
    ok: 'Ok',
    previous: 'Précédent',
    new: 'Nouveau',
    no: 'Non',
    save: 'Enregistrer',
    sendMessage: 'Envoyer',
    validate: 'Valider',
    yes: 'Oui',
  },

  dialog: {
    sendingEmail: 'Envoi en cours...',
  },

  enum: {
    no: 'Non',
    yes: 'Oui',
    dark: 'Sombre',
    light: 'Clair',
  },

  error: {
    between: '{field} doit être entre {min} et {max} caractères',
    format: "Le format n'est pas valide",
    maxLength: '{field} doit faire moins de {lenght} caractères',
    minLength: '{field} doit faire au moins {lenght} caractères',
    required: '{field} est un champ obligatoire',
    unique: 'Le champ doit être unique',
    email: {
      required: "L'email est obligatoire",
      email: "Le format n'est pas valide",
    },
    password: {
      match: 'Les mots de passe ne correspondent pas',
    },
  },

  field: {
    email: 'Email',
    enterYourPassword: 'Entrez votre mot de passe',
    firstName: 'Prénom',
    fullName: 'Nom',
    lastName: 'Nom de famille',
    login: 'Login',
    message: 'Message',
    password: 'Mot de passe',
    required: 'Requis',
    retypeYourPassword: 'Retaper votre mot de passe',
    title: 'Titre',
  },

  header: {
    answer: 'Réponse',
    category: 'Catégorie',
    question: 'Question',
    country: 'Pays',
    capital: 'Capitale',
    flag: 'Drapeau',
  },

  hint: {

  },

  navigation: {
    home: 'Accueil',
    about: 'À propos',
    contactUs: 'Contactez nous',
    skills: 'Compétences',
  },

  panel: {
    home: {
      subtitle1: "Pour du conseil ou du développement, nous disposons d'une équipe de professionnels qui s'adapte à vos besoins.",
      subtitle2: "Avec plus de 15 ans d'expérience dans le développement logiciel, nous concevons et réalisons les solutions qui vous conviennent.",

      content: {
        title: 'Nos Compétences',
        description: "Avec notre savoir-faire, vous êtes assuré de travailler avec les meilleurs développeurs.",
        featConseil: "Conseil : Orientation et structuration de projets, conseils techniques, méthodologie, ateliers logiciel, recettes, formations...",
        featDb: "Database : Modélisation de base, audit, restructuration.",
        featSoftware: "Logiciels : Conception, développement from scratch, audit, correction de bugs, ergonomie, ajout de fonctionnalités…",
      },

      contact: {
        title: 'Contactez-nous',
        message: "Envoyez-nous un message pour de plus amples informations, un conseil, un devis. Nous vous répondrons dans les plus brefs délais.",
      },
    },

    skills: {
      title: "Compétences",
      subtitle1: "Notre principal domaine d'activité est le développement C# / WPF",
      subtitle2: 'Et voici la liste complète de nos compétences',
    },
  },

  message: {
    confirm: 'Confirmer',
    error: 'Erreur',
    failed: 'Échec',
    tip: 'Astuce',
    notAvailableYet: 'Pas encore disponible',
    saved: 'Sauvegarder',
    success: 'Réussi',
    welcome: 'Bienvenue',
  },

  snackbar: {
    saved: 'Sauvegardé',
    success: 'Réussit',
    failed: 'Échec',
  },

}
